export const ACTIVE_WOMENS_SEASON = 2026;

export const WOMENS_SEASONS = Object.freeze([
  ACTIVE_WOMENS_SEASON,
  2025,
  2024,
  2023,
  2022,
  2021,
]);

export function isSupportedWomensSeason(value) {
  const season = Number(value);
  return Number.isInteger(season) && WOMENS_SEASONS.includes(season);
}

export function parseWomensSeason(value, fallback = ACTIVE_WOMENS_SEASON) {
  if (value === null || value === undefined || value === '') return fallback;
  return isSupportedWomensSeason(value) ? Number(value) : null;
}
